module.exports = __webpack_public_path__ + "static/media/4forty-blue.ba5cb1c6.svg";